export enum ShiftType {
  STANDARD = 'STANDARD',
  EXPRESS = 'EXPRESS',
  DECLARED = 'DECLARED',
}

export enum ShiftCreationType {
  STANDARD = ShiftType.STANDARD,
  EXPRESS = ShiftType.EXPRESS,
}

export enum CompensationType {
  TO_BE_PAID = 'TO_BE_PAID',
  TO_BE_RECOVERED = 'TO_BE_RECOVERED',
  FIXED_RATE_OVERTIME = 'FIXED_RATE_OVERTIME',
}

export enum ContractType {
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME',
}

export enum ShiftCreationStrategy {
  SINGLE_SHIFT = 'SINGLE_SHIFT',
  ONE_SHIFT_PER_PERIOD = 'ONE_SHIFT_PER_PERIOD',
}

export enum ShiftAssignmentType {
  NETWORK = 'NETWORK',
  HUBLO_POOL = 'HUBLO_POOL',
  POOL_CANDIDATE = 'POOL_CANDIDATE',
  AGENCY_TEMPORARY_WORKER = 'AGENCY_TEMPORARY_WORKER',
  AGENCY_FREELANCE = 'AGENCY_FREELANCE',
  AGENCY_INTERIM = 'AGENCY_INTERIM',
}

export enum ShiftPeriod {
  DAY = 'DAY',
  NIGHT = 'NIGHT',
  MIXED = 'MIXED',
}

export enum CanceledBecause {
  CANCEL_BY_WORKER = 1,
  WORKER_DID_NOT_COME = 2,
  INSTITUTION_DEMAND = 3,
  NO_APPLY_IN_TIME = 4,
  ACTIVITY_REDUCTION = 5,
  WORKER_FIND_OUT_OF_NETWORK = 6,
  INSTITUTION_INTERIM = 7,
  INSTITUTION_NO_WORKER_NEEDED = 8,
  INSTITUTION_TYPING_ERROR = 9,
  NB_HOUR_FOR_WORKER_OVER_COME = 10,
  INSTITUTION_OTHER_REASON = 11,
  FIND_OUT_OF_HUBLO = 12,
  INTERNAL_ORGANISATION = 13,
}
